import { useHomeData } from '@/hooks/useHomeData';
import { useSacola } from '@/hooks/useSacola';
import { registrarEvento } from '@/services/googleAnalytics';
import { recuperarCombo } from '@/services/marketplaceService';
import { Combo } from '@/types/combo';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function usePlanoPageHook(
  $comboSlug: string,
  router: AppRouterInstance,
) {
  const caminhoURL = usePathname();
  const { combos } = useHomeData();
  const {
    itens,
    planoASerEditado,
    adicionarItemASacola,
    atualizarPlanoSacola,
    existeProdutoNaSacola,
  } = useSacola();

  const [combo, setCombo] = useState<Combo | null>(null);
  const [produtoSelecionado, setProdutoSelecionado] = useState<string | null>();

  useEffect(() => {
    async function recuperarInfoCombo(comboSlug: string) {
      const comboFromServer = await recuperarCombo(comboSlug);
      setProdutoSelecionado(
        comboFromServer.produtos.find((produto) => produto.variavel)?.id,
      );
      setCombo(comboFromServer);
    }

    if (combos?.length && $comboSlug) {
      const acharComboNaListaHome = combos.find(
        (combo) => combo.slug === decodeURI($comboSlug),
      );

      if (acharComboNaListaHome) {
        setProdutoSelecionado(
          acharComboNaListaHome.produtos.find((produto) => produto.variavel)
            ?.id,
        );
        setCombo(acharComboNaListaHome);
      }
    } else {
      recuperarInfoCombo($comboSlug);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [$comboSlug]);

  function adicionarPlanoASacola() {
    if (!combo || !combo?.produtos) return;

    registrarEvento('combo_clicou_adicionar_sacola', {
      comboID: combo?.comboID,
      combo: combo?.nome,
    });
    registrarEvento('add_to_cart', {
      currency: 'BRL',
      value: combo?.preco,
      items: [{ item_id: combo?.comboID, item_name: combo?.nome }],
    });

    adicionarItemASacola({
      plano: combo,
      opcaoSelecionadaPlano: combo.produtos.find(
        (produto) => produto.id === produtoSelecionado,
      ),
      quantidade: 1,
    });
  }

  function comprarAgora() {
    if (!combo || !combo?.produtos) return;

    registrarEvento('combo_clicou_comprar_agora', {
      comboID: combo?.comboID,
      combo: combo?.nome,
    });
    registrarEvento('add_to_cart', {
      currency: 'BRL',
      value: combo?.preco,
      items: [{ item_id: combo?.comboID, item_name: combo?.nome }],
    });

    adicionarItemASacola({
      plano: combo,
      opcaoSelecionadaPlano: combo.produtos.find(
        (produto) => produto.id === produtoSelecionado,
      ),
      quantidade: 1,
    });

    if (!existeProdutoNaSacola(itens)) {
      router.push('/sacola', { scroll: true });
    }
  }

  function atualizarProdutoPlanoSacola() {
    if (!combo || !combo?.produtos) return;

    const novoProdutoSelecionado = combo.produtos.find(
      (produto) => produto.id === produtoSelecionado,
    );

    if (!novoProdutoSelecionado) return;

    atualizarPlanoSacola({
      plano: combo,
      opcaoSelecionadaPlano: novoProdutoSelecionado,
    });

    router.push('/sacola');
  }

  function visualizarTermosCombo() {
    sessionStorage.setItem('termoHTML', combo?.termosDeUso?.toString() ?? '');
    router.push('/termos', { scroll: true });
  }

  return {
    caminhoURL,
    combo,
    produtoSelecionado,
    planoASerEditado,
    setProdutoSelecionado,
    atualizarProdutoPlanoSacola,
    adicionarPlanoASacola,
    adicionarItemASacola,
    atualizarPlanoSacola,
    comprarAgora,
    visualizarTermosCombo,
  };
}
